import { store } from "../redux/store";
import {
  setGetLatestReports,
  setLeadBoardRefresh,
  setLeadFormRefresh,
  setTaskBoardRefresh,
  setTaskReminders,
  setVoxbayDispositionData,
  setVoxbayDispositionDataForEnquiry,
  setVoxbayDispositionFlag,
} from "../service/websocketNotificationsSlice";

const bellSoundUrl =
  "https://commons-image.s3.ap-south-1.amazonaws.com/bellSound.mp3";

const SOCKET_SERVER_URL = process.env.REACT_APP_SOCKET_SERVER_URL || "";

interface CustomWebSocket extends WebSocket {
  onopen: ((this: WebSocket, ev: Event) => any) | null;
  onmessage: ((this: WebSocket, ev: MessageEvent) => any) | null;
  onerror: ((this: WebSocket, ev: Event) => any) | null;
  onclose: ((this: WebSocket, ev: CloseEvent) => any) | null;
}

let heartbeatTimeout: ReturnType<typeof setTimeout>;
let reconnectAttempts = 0;
const maxReconnectAttempts = 5;
let socket: CustomWebSocket;

let bellSound = new Audio(bellSoundUrl);
let isLoggedIn = true;

const stopHeartbeat = () => {
  clearTimeout(heartbeatTimeout);
};

export const initSocket = (
  userId: string,
  instituteId: string
): CustomWebSocket => {
  socket = new WebSocket(
    `${SOCKET_SERVER_URL}/?userId=${userId}&instituteId=${instituteId}`
  ) as CustomWebSocket;

  const startHeartbeat = () => {
    clearTimeout(heartbeatTimeout);
    heartbeatTimeout = setTimeout(() => {
      if (socket.readyState === WebSocket.OPEN) {
        socket.send(JSON.stringify({ action: "heartbeat" }));
      }
      startHeartbeat();
    }, 240000);
  };

  const resetHeartbeat = () => {
    clearTimeout(heartbeatTimeout);
    startHeartbeat();
  };

  socket.onopen = () => {
    reconnectAttempts = 0;
    startHeartbeat();
  };

  socket.onmessage = (event) => {
    try {
      resetHeartbeat();
      const message = JSON.parse(event.data);

      if (!message.data || !message.data.message || !message.data.message.data) {
        return;
      }

      const notificationData = JSON.parse(message.data.message.data);

      if (notificationData.type === "TASK_REMINDER") {
        store.dispatch(setTaskReminders(notificationData.otherDetails));
        bellSound
          .play()
          .catch((error) => console.error("###Error playing bell sound:", error));
      } else if (notificationData.type === "ENQUIRY_ADDED_OR_UPDATED") {
        store.dispatch(setLeadBoardRefresh("REFRESH_BOARD"));

      } else if (
        notificationData.type === "TASK_ADDED_OR_UPDATED" ||
        notificationData.type === "TASK_DELETED" ||
        notificationData.type === "TASK_COMPLETED" ||
        notificationData.type === "TASK_STATE_CHANGED" ||
        notificationData.type === "TASK_CREATED" ||
        notificationData.type === "TASK_EDITED" ||
        notificationData.type === "TASK_STATUS_UPDATED" ||
        notificationData.type === "TASK_ASSIGNEE_UPDATED" ||
        notificationData.type === "TASK_PRIORITY_UPDATED" ||
        notificationData.type === "GENERAL_TASK_DELETED" ||
        notificationData.type === "GENERAL_TASK_CREATED" ||
        notificationData.type === "GENERAL_TASK_UPDATED"
      ) {
        store.dispatch(setTaskBoardRefresh("REFRESH_TASK_BOARD"));
        store.dispatch(setLeadBoardRefresh("REFRESH_BOARD"));
      } else if (notificationData.type === "REPORT_ADDED") {
        store.dispatch(setGetLatestReports("REFRESH_REPORT"));
      } else if (notificationData.type === "ADD_LEAD_FORM") {

        store.dispatch(setLeadFormRefresh("ADD_LEAD_FORM"));
      } else if (notificationData.type === "INDIVIDUAL_TASK_REMINDER") {

        store.dispatch(setTaskReminders(notificationData.otherDetails));
        bellSound
          .play()
          .catch((error) => console.error("###Error playing bell sound:", error));
      } else if (notificationData.type === "STAGE_TASK_REMINDER") {

        store.dispatch(setTaskReminders(notificationData.otherDetails));
        bellSound
          .play()
          .catch((error) => console.error("###Error playing bell sound:", error));
      } else if (notificationData.type === "GLOBAL_TASK_REMINDER") {
        store.dispatch(setTaskReminders(notificationData.otherDetails));
        bellSound
          .play()
          .catch((error) => console.error("###Error playing bell sound:", error));
      } else if (
        notificationData?.type === "CREATE_LEAD" ||
        notificationData?.type === "LEAD_EXISTS"
      ) {
        store.dispatch(setVoxbayDispositionFlag(notificationData.type));
        store.dispatch(setVoxbayDispositionData(notificationData.otherDetails));
        store.dispatch(
          setVoxbayDispositionDataForEnquiry(notificationData.enquiryDetails)
        );
      }
    } catch (error) {
      console.error('###[WebSocket] Error parsing message:', error);
    }
  };

  socket.onerror = (event) => {
    console.error("### WebSocket connection error");
  };

  socket.onclose = (event) => {
    stopHeartbeat();

    if (reconnectAttempts < maxReconnectAttempts) {
      const delay = Math.pow(2, reconnectAttempts) * 1000;
      setTimeout(() => {
        reconnectAttempts++;
        initSocket(userId, instituteId);
      }, delay);
    }
  };

  return socket;
};

export const closeSocket = () => {
  if (socket) {
    stopHeartbeat();
    reconnectAttempts = maxReconnectAttempts;
    socket.close();
  }
};
